import React from "react";

// components
// import CreateTraining from "../misc/CreateTraining";
import Button from "../../../component/element/forms/Button";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  delete_training,
  get_trainings,
} from "../../../services/apis/training";
import { ITraining } from "../../../store/types/training";
import { useNavigate } from "react-router-dom";
import { ColumnDef } from "@tanstack/react-table";
import { IStateCountry } from "../../../store/types/misc";
import { FaPlus } from "react-icons/fa6";

const Training = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const trainings = useAppSelector(({ training }) => training.trainings);
  const onLoad = React.useCallback(() => {
    get_trainings(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<ITraining>[] = [
    {
      accessorKey: "image",
      header: "Image",
      cell: ({ getValue }) => {
        const image = getValue() as string;
        return (
          <div className="w-full max-w-sm">
            <img
              loading="lazy"
              src={image}
              alt={image}
              className="w-11 h-auto object-cover rounded-lg"
            />
          </div>
        );
      },
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    {
      accessorKey: "state",
      header: "Location",
      cell: ({ getValue }) => {
        const state = getValue() as IStateCountry;
        return (
          <span>
            {state.name}, {state.country.name}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <ItemAction
            onView={() => navigate(`/training/${data.id}`)}
            onEdit={() => navigate(`/training/edit/${data.id}`)}
            onDelete={() => delete_training(dispatch, data.id)}
          />
        );
      },
    },
  ];

  return (
    <div>
      <div className="w-full flex justify-between items-center mb-6">
        <h2 className="font-bold text-xl capitalize mb-0">Training</h2>

        <Button
          type="button"
          title="Create"
          children={<FaPlus className="mr-2" />}
          onClick={() => navigate("/training/create")}
          className="px-4"
        />
      </div>

      <div>
        <DataTable columns={columns} data={trainings} />
      </div>
    </div>
  );
};

export default Training;
